export function getDynasty() {
  return () =>
    fetch(
      `${process.env.REACT_APP_API_HTTP}://${process.env.REACT_APP_API_URL}:${process.env.REACT_APP_API_PORT}/api/v1/analytics/dynasty`
    ).then((res) => res.json());
}
